import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";
import img1 from "../../assets/image/meeting-01.jpg";
import img2 from "../../assets/image/meeting-02.jpg";
import img3 from "../../assets/image/meeting-03.jpg";
import img4 from "../../assets/image/meeting-04.jpg";
import bgservices from "../../assets/image/meetings-page-bg.jpg";

const AboutHome = () => {
  // const { category } = useSelector((state) => state.Productslice);
  // const { t } = useTranslation();

  const pagination = {
    clickable: true,
  };
  return (
    <section
      className="upcoming-meetings"
      id="meetings"
      style={{ backgroundImage: `url(${bgservices})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2>Upcoming Meetings</h2>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="categories">
              <h4>Meeting Catgories</h4>
              <ul>
                <li>
                  <a href="#">Sed tempus enim leo</a>
                </li>
                <li>
                  <a href="#">Aenean molestie quis</a>
                </li>
                <li>
                  <a href="#">Cras et metus vestibulum</a>
                </li>
                <li>
                  <a href="#">Nam et condimentum</a>
                </li>
                <li>
                  <a href="#">Phasellus nec sapien</a>
                </li>
              </ul>
              <div className="main-button-red">
                <a href="meetings.html">All Upcoming Meetings</a>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="row">
              <div className="col-lg-6">
                <div className="meeting-item">
                  <div className="thumb">
                    <div className="price">
                      <span>$22.00</span>
                    </div>
                    <a href="meeting-details.html">
                      <img src={img1} alt="New Lecturer Meeting" />
                    </a>
                  </div>
                  <div className="down-content">
                    <div className="date">
                      <h6>
                        Nov <span>10</span>
                      </h6>
                    </div>
                    <a href="meeting-details.html">
                      <h4>New Lecturers Meeting</h4>
                    </a>
                    <p>
                      Morbi in libero blandit lectus
                      <br />
                      cursus ullamcorper.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="meeting-item">
                  <div className="thumb">
                    <div className="price">
                      <span>$36.00</span>
                    </div>
                    <a href="meeting-details.html">
                      <img src={img2} alt="Online Teaching" />
                    </a>
                  </div>
                  <div className="down-content">
                    <div className="date">
                      <h6>
                        Nov <span>24</span>
                      </h6>
                    </div>
                    <a href="meeting-details.html">
                      <h4>Online Teaching Techniques</h4>
                    </a>
                    <p>
                      Morbi in libero blandit lectus
                      <br />
                      cursus ullamcorper.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="meeting-item">
                  <div className="thumb">
                    <div className="price">
                      <span>$14.00</span>
                    </div>
                    <a href="meeting-details.html">
                      <img src={img3} alt="Higher Education" />
                    </a>
                  </div>
                  <div className="down-content">
                    <div className="date">
                      <h6>
                        Nov <span>26</span>
                      </h6>
                    </div>
                    <a href="meeting-details.html">
                      <h4>Higher Education Conference</h4>
                    </a>
                    <p>
                      Morbi in libero blandit lectus
                      <br />
                      cursus ullamcorper.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="meeting-item">
                  <div className="thumb">
                    <div className="price">
                      <span>$48.00</span>
                    </div>
                    <a href="meeting-details.html">
                      <img src={img4} alt="Student Training" />
                    </a>
                  </div>
                  <div className="down-content">
                    <div className="date">
                      <h6>
                        Nov <span>30</span>
                      </h6>
                    </div>
                    <a href="meeting-details.html">
                      <h4>Student Training Meetup</h4>
                    </a>
                    <p>
                      Morbi in libero blandit lectus
                      <br />
                      cursus ullamcorper.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHome;
